module.exports = __webpack_public_path__ + "img/14.f371c2c7.jpg";